import {create} from "zustand";
import {ConfirmationDialog} from "@rio-cloud/rio-uikit";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import {v4} from "uuid";

type DialogState = {
    id: string,
    isOpen: boolean
    content: string,
    title: string,
    onConfirm: () => void,
    //Can't really do that using the prebuild confirm dialog. I'll add it later.
    isLoading: boolean,
}

type OpenDialogProps = {
    content: DialogState["content"],
    title: DialogState["title"],
    onConfirm: DialogState["onConfirm"],
}

type StateType = {
    dialogs: DialogState[]
    openDialog: (title: string, content: string, onConfirm: () => void) => void,
    closeDialog: (id: string) => void,
}

const newDialog = (params: OpenDialogProps): DialogState => {
    return {
        id: v4(),
        isOpen: true,
        content: params.content,
        title: params.title,
        onConfirm: params.onConfirm,
        isLoading: false
    }
}

const useConfirmDialogState = create<StateType>(set => ({
    dialogs: [],
    openDialog: (title: string, content: string, onConfirm: () => void) => set(state => ({
        dialogs: [...state.dialogs, newDialog({title, content, onConfirm: onConfirm})],
    })),
    closeDialog: (id: string) => set(state => ({
        dialogs: [...state.dialogs.filter(dialog => dialog.id !== id)],
    }))

}))

export const useOpenConfirmDialog = () => {
    const openDialog = useConfirmDialogState(state => state.openDialog)

    return ({title, content, onConfirm}: OpenDialogProps) => {
        openDialog(title, content, onConfirm)
    }
}

export const GlobalConfirmDialogRenderer = () => {
    const dialogs = useConfirmDialogState(state => state.dialogs)
    const closeDialog = useConfirmDialogState(state => state.closeDialog)

    return <>{dialogs.map(dialog => <ConfirmationDialog key={dialog.id}
                                                        show={dialog.isOpen}
                                                        title={dialog.title}
                                                        content={dialog.content}
                                                        bsSize={Dialog.SIZE_SM}
                                                        onClickConfirm={() => {
                                                            dialog.onConfirm()
                                                            closeDialog(dialog.id)
                                                        }}
                                                        onClickCancel={() => closeDialog(dialog.id)}
                                                        cancelButtonText='Cancel'
                                                        confirmButtonText={
                                                            <>
                                                                <span className='rioglyph rioglyph-ok margin-right-5'/>
                                                                <span>Confirm</span>
                                                            </>
                                                        }
                                                        useOverflow
    />)}
    </>
}